"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionFunctions = void 0;
const delete_1 = require("./delete");
const hit_1 = require("./hit");
const move_1 = require("./move");
exports.actionFunctions = {
    move: move_1.doMove,
    delete: delete_1.doDelete,
    hit: hit_1.doHit,
};
